import {Component, Input, OnDestroy, OnInit} from '@angular/core';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.css']
})
export class TimerComponent implements OnInit, OnDestroy {

  @Input() end!: string;

  interval: number | null = null;
  endDate!: Date;
  left!: string;

  constructor() {
  }

  ngOnInit(): void {
    this.endDate = new Date(this.end);
    this.updateLeft();
    this.interval = setInterval(() => {
      this.updateLeft();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.interval !== null) {
      clearInterval(this.interval);
    }
  }

  updateLeft(): void {
    const leftMilliseconds = this.endDate.getTime() - new Date().getTime();
    if (leftMilliseconds < 0) {
      this.left = 'время истекло';
      if (this.interval !== null) {
        clearInterval(this.interval);
      }
      return;
    }

    const milliseconds = leftMilliseconds % 1000;

    const leftSeconds = Math.floor(leftMilliseconds / 1000);
    const seconds = leftSeconds % 60;

    const leftMinutes = Math.floor(leftSeconds / 60);
    const minutes = leftMinutes % 60;

    const hours = Math.floor(leftMinutes / 60);

    let left = '';
    if (hours) {
      left += `${hours} ч`;
    }
    if (minutes) {
      if (left) {
        left += ' ';
      }
      left += `${minutes} мин`;
    }
    if (seconds) {
      if (left) {
        left += ' ';
      }
      left += `${seconds} с`;
    }
    this.left = left;
  }

}
